import { render, staticRenderFns } from "./StartProject.vue?vue&type=template&id=a1ff7148&scoped=true&"
import script from "./StartProject.vue?vue&type=script&lang=js&"
export * from "./StartProject.vue?vue&type=script&lang=js&"
import style0 from "./StartProject.vue?vue&type=style&index=0&id=a1ff7148&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ff7148",
  null
  
)

export default component.exports